import styled from 'styled-components';


export const Image = styled.img`
  
  width: 300px;
  margin-top:200px;
  margin-left:41%;
`;

